import src from "IMAGE";
export default { src, width: 71, height: 71, blurWidth: 0, blurHeight: 0};
